import { lazy } from "react";

import { createRouter } from "@tanstack/react-router";
import { Route as rootRoute } from "./routes/__root";
import { Route as indexRoute } from "./routes/index";
import { Route as loginRoute } from "./routes/login";
import { Route as registerRoute } from "./routes/register";
import { Route as forgotPasswordRoute } from "./routes/forgot-password";
import { Route as notFoundRoute } from "./routes/page-not-found";
import { Route as unauthorizedRoute } from "./routes/unauthorized";
import { Route as invalidAccessRoute } from "./routes/invalid-access";
import { Route as authenticatedRoute } from "./routes/_authenticated";

import {
  dashboardRoute,
  analyticsRoute,
  mgtRoute,
  adminUsersRoute,
  adminUsersAddRoute,
  adminUsersDetailRoute,
  rolesRoute,
  farmersRoute,
  farmersAddRoute,
  farmersDetailRoute,
  farmersEditRoute,
  customersRoute,
  customerDetailRoute,
  vendorsRoute,
  commRoute,
  smsRoute,
  emailRoute,
  pushNotificationRoute,
  priceRoute,
  priceListRoute,
  priceAddRoute,
  priceDetailRoute,
  contentRoute,
  newsRoute,
  newsAddRoute,
  newsDetailRoute,
  aboutRoute,
  contactRoute,
  partnersRoute,
  partnersAddRoute,
  partnersDetailRoute,
  publicationRoute,
  publicationAddRoute,
  publicationDetailRoute,
  toolsRoute,
  toolsAddRoute,
  toolsDetailRoute,
  videoRoute,
  videoAddRoute,
  videoDetailRoute,
  faqRoute,
  faqAddRoute,
  faqDetailRoute,
  settingsRoute,
  socialMediaRoute,
  termsAndConditionsRoute,
  privacyPolicyRoute,
  productsRoute,
  productsListRoute,
  productDetailRoute,
  productEditRoute,
  categoriesRoute,
  categoryDetailRoute,
  reviewsRoute,
  promotionsRoute,
  promotionPlansRoute,
  promotionPlanAddRoute,
  promotionPlanDetailRoute,
  accountSettingsRoute,
} from "./routes/routes";

const NotFound = lazy(() => import("./views/default/NotFound"));

const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  registerRoute,
  forgotPasswordRoute,
  notFoundRoute,
  unauthorizedRoute,
  invalidAccessRoute,
  authenticatedRoute.addChildren([
    dashboardRoute,
    analyticsRoute,
    mgtRoute.addChildren([
      adminUsersRoute,
      adminUsersAddRoute,
      adminUsersDetailRoute,
      rolesRoute,
      farmersRoute,
      farmersAddRoute,
      farmersDetailRoute,
      farmersEditRoute,
      customersRoute,
      customerDetailRoute,
      vendorsRoute,
    ]),
    commRoute.addChildren([smsRoute, emailRoute, pushNotificationRoute]),
    priceRoute.addChildren([priceListRoute, priceAddRoute, priceDetailRoute]),
    contentRoute.addChildren([
      newsRoute,
      newsAddRoute,
      newsDetailRoute,
      partnersRoute,
      partnersAddRoute,
      partnersDetailRoute,
      publicationRoute,
      publicationAddRoute,
      publicationDetailRoute,
      toolsRoute,
      toolsAddRoute,
      toolsDetailRoute,
      videoRoute,
      videoAddRoute,
      videoDetailRoute,
      faqRoute,
      faqAddRoute,
      faqDetailRoute,
    ]),
    settingsRoute.addChildren([socialMediaRoute, aboutRoute, contactRoute, termsAndConditionsRoute, privacyPolicyRoute]),
    productsRoute.addChildren([
      productsListRoute,
      productDetailRoute,
      productEditRoute,
      categoriesRoute,
      categoryDetailRoute,
      reviewsRoute,
      promotionsRoute,
      promotionPlansRoute,
      promotionPlanAddRoute,
      promotionPlanDetailRoute,
    ]),
    accountSettingsRoute,
  ]),
]);

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultNotFoundComponent: NotFound,
  scrollRestoration: false,
});

export default router;
